<template>
  <div
    class="rounded-sm bg-ontick-steel-500 w-36 overflow-hidden relative flex items-center"
  >
    <div
      :class="color"
      :style="`width: ${progress}%;`"
      class="absolute top-0 left-0 h-full transition-all"
    ></div>
    <span
      class="absolute left-2 top-1/2 -translate-y-1/2 text-white"
      :class="{ 'font-semibold': text.left && text.right }"
      v-if="text.left"
    >
      {{ text.left }}
    </span>
    <span
      class="absolute right-2 top-1/2 -translate-y-1/2 text-white font-semibold"
      v-if="text.right"
    >
      {{ text.right }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    max: {
      type: Number,
    },
    filled: {
      type: Number,
    },
    text: {
      type: Object,
    },
  },

  computed: {
    progress() {
      return (this.filled / this.max) * 100;
    },
    color() {
      return "bg-ontick-blue-600";
    },
  },

  methods: {
    // https://stackoverflow.com/questions/175739/how-can-i-check-if-a-string-is-a-valid-number
    isNumeric(str) {
      if (typeof str != "string") return false; // we only process strings!
      return (
        !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(str))
      ); // ...and ensure strings of whitespace fail
    },
  },
};
</script>

<style></style>
